module.exports = __webpack_public_path__ + "static/img/how-it-work-2.42474c2e.svg";